import Stack from '@/components/Custom/ModalStack';

export default function PrivateTeamTeamIdPersonAddLayoutRoute() {
  return <Stack />;
}
